import Users from './container'

export default Users
